import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-search',
  standalone: true,
  templateUrl: '../../assets/search.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamSearchIcon {}
